//Install
import React, { Component } from "react";
//Install
import { ReactComponent as Arrow } from "../../Media/Icon/002.svg";

//Element
class Menu extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("menu", { className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB u9g2b1" },
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/" },
                    //Element
                    "Başlangıç"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d cH8711" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "#" },
                    //Element
                    "Kurumsal"
                ),
                //Element
                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB gBt584" },
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/hakkimizda" },
                            //Element
                            "Hakkımızda",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/tarihce" },
                            //Element
                            "Tarihçe",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/subeler" },
                            //Element
                            "Şubeler",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/yetki-belgeleri" },
                            //Element
                            "Yetki Belgeleri",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d cH8711" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "#" },
                    //Element
                    "Sunulan Hizmetler"
                ),
                //Element
                React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB gBt584" },
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/aydinlatma" },
                            //Element
                            "Aydınlatma",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/pano-imalati" },
                            //Element
                            "Pano İmalat",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/elektrik-taahhut" },
                            //Element
                            "Elektrik Taahhüt",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/yenilenebilir-enerji" },
                            //Element
                            "Yenilenebilir Enerji",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    ),
                    //Element
                    React.createElement("li", { className: "S0u16d C96Q4r" },
                        //Element
                        React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/orta-gerilim-tesisleri" },
                            //Element
                            "Orta Gerilim Tesisleri",
                            //Element
                            React.createElement(Arrow, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/projeler" },
                    //Element
                    "Projeler"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/surdurulebilirlik" },
                    //Element
                    "Sürdürülebilirlik"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/kariyer" },
                    //Element
                    "Kariyer"
                )
            ),
            //Element
            React.createElement("li", { className: "S0u16d" },
                //Element
                React.createElement("a", { className: "S0u16d", href: "/iletisim" },
                    //Element
                    "İletişim"
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Menu;